import { ReturnQuestionProjection, ReturnQuestionTypesWithChildren } from "./returnQuestion";
import { ReturnQuestionType } from "./returnQuestion.constants";

const returnQuestionHasChildren = (
  question: ReturnQuestionProjection,
): question is ReturnQuestionProjection<ReturnQuestionTypesWithChildren> =>
  [
    ReturnQuestionType.HOST_DEFAULT,
    ReturnQuestionType.HOST_SELECT,
    ReturnQuestionType.HOST_STACK,
    ReturnQuestionType.HOST_TEXTAREA,
    ReturnQuestionType.HOST_RADIO_GROUP,
    ReturnQuestionType.OPTION,
  ].includes(question.type);

export { returnQuestionHasChildren };
